/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Matterport_UrlInputs */

const cs_form_matterport_url = /** @type {(inputs: Form_Matterport_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Matterport`)
};

const en_form_matterport_url = /** @type {(inputs: Form_Matterport_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport URL`)
};

/**
* | output |
* | --- |
* | "Matterport URL" |
*
* @param {Form_Matterport_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_matterport_url = /** @type {((inputs?: Form_Matterport_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Matterport_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_matterport_url(inputs)
	return cs_form_matterport_url(inputs)
});